import styled from '@emotion/styled';
import { AvatarStylesProps } from './avatar.types';
import { css } from '@emotion/react';

const fontSizeMap = {
  36: 14,
  40: 16,
  56: 20,
  124: 48,
};

export const Avatar = styled.div<AvatarStylesProps>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.colors.technical.gray[5]};
  color: ${({ theme }) => theme.colors.primary.dark};
  font-weight: 600;
  font-size: ${({ size }) => fontSizeMap[size]}px;
  outline: none;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  transition: background-color 0.2s ease;

  ${({ isClickable, theme }) =>
    isClickable &&
    css`
      &:hover {
        background-color: ${theme.colors.technical.gray[15]};
      }

      &:active {
        background-color: ${theme.colors.technical.gray[30]};
      }
    `}

  ${({ isFocusVisible, theme }) =>
    isFocusVisible &&
    css`
      outline: 2px solid ${theme.colors.primary.normal};
      outline-offset: -2px;
    `}
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
